import { useState, useEffect } from 'react';
import { TemplateBlock } from '../types/blockTypes';
import { BlocksService } from '../services/blocksService';

export const useTemplateBlocks = (workpillId?: string) => {
  const [blocks, setBlocks] = useState<TemplateBlock[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [templateId, setTemplateId] = useState<string | undefined>();

  const fetchBlocks = async () => {
    try {
      setIsLoading(true);
      setError(null);

      // Obtener el template_id del workpill si existe (para operaciones de inserción)
      if (workpillId) {
        const fetchedTemplateId = await BlocksService.getTemplateIdFromWorkpill(workpillId);
        setTemplateId(fetchedTemplateId || undefined);
      } else {
        setTemplateId(undefined);
      }

      // Obtener todos los bloques sin filtrar por template_id
      const fetchedBlocks = await BlocksService.getAllBlocks();
      console.log('🔍 [HOOK DEBUG] Bloques recibidos en hook:', fetchedBlocks.length);
      console.log('🔍 [HOOK DEBUG] Bloques detallados:', fetchedBlocks);
      setBlocks(fetchedBlocks);

    } catch (err) {
      console.error('Error fetching blocks:', err);
      setError(err instanceof Error ? err.message : 'Failed to load blocks');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBlocks();
  }, [workpillId]);

  return {
    blocks,
    isLoading,
    error,
    templateId,
    refetch: fetchBlocks
  };
};

